import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import { GET_ME_QUERY_KEY } from './useGetMe';

import { MeResponse } from '@/services/AuthService';
import CustomerService, {
  UpdateShopifyCredentialsDto,
} from '@/services/CustomerService';

export function useUpdateShopifyCredentials() {
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: (updateShopifyCredentialsDto: UpdateShopifyCredentialsDto) =>
      CustomerService.updateShopifyCredentials(updateShopifyCredentialsDto),
    onMutate: (updateShopifyCredentialsDto) => {
      const previousData =
        queryClient.getQueryData<MeResponse>(GET_ME_QUERY_KEY);

      queryClient.setQueryData<MeResponse>(
        GET_ME_QUERY_KEY,
        produce((draft) => {
          if (draft?.customer) {
            draft.customer.shopifyAccessToken =
              updateShopifyCredentialsDto.shopifyAccessToken;
            draft.customer.shopifyUrl = updateShopifyCredentialsDto.shopifyUrl;
          }
        }),
      );

      return { previousData };
    },
    onError: (_error, _data, context) => {
      queryClient.setQueryData<MeResponse>(
        GET_ME_QUERY_KEY,
        context?.previousData,
      );
    },
  });

  return {
    updateShopifyCredentials: mutateAsync,
    isLoading: isPending,
  };
}
